import config from 'services/table/const';
import Action from './table.action';
import { formatDate, currencyFormat } from 'utilities/common';
import * as Tb from 'react-icons/tb';

let table = { ...config };

table.url = '/finance/receivable';
table.columns = {
  code: {
    title: '# Code',
    sortable: true,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.code}
          </div>
          {row?.ref_code && <small className="info">{row?.ref_code}</small>}
          <small className="info">
            {formatDate(row?.created_at, 'DD/MM/YYYY') || '-'}
          </small>
        </div>
      );
    },
  },

  customer_id: {
    title: 'Client',
    alias: 'customer.id',
    sortable: true,
    width: 250,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fw-semibold text-uppercase">
            {row?.customer?.name}
          </div>
          <small className="info text-uppercase">
            {row?.customer?.company_name}
          </small>
        </div>
      );
    },
  },

  project_id: {
    title: 'Project',
    alias: 'project.id',
    sortable: true,
    width: 150,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.project?.name || '-'}
          </div>
          <small className="info text-uppercase">
            {row?.project?.type} - {row?.project?.invoice_method}
          </small>
        </div>
      );
    },
  },

  periode_project: {
    title: 'Periode',
    sortable: true,
    width: 80,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 text-uppercase">
            {formatDate(row?.periode_project, 'YYYYMM')}
          </div>
        </div>
      );
    },
  },
  invoiced_at: {
    title: 'Invoiced Date',
    sortable: false,
    width: 80,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {formatDate(row?.schedule_at, 'DD/MM/YYYY')}
        </div>
      );
    },
  },

  due_at: {
    title: 'Due Date',
    sortable: false,
    width: 80,
    class: 'text-center',
    classHeader: 'text-center',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {formatDate(row?.due_at, 'DD/MM/YYYY')}
        </div>
      );
    },
  },

  total_paid: {
    title: 'Remaining Invoice',
    sortable: false,
    width: 100,
    class: 'text-end',
    classHeader: 'text-end',
    component: (row) => {
      return (
        <div className="text-ellipsis">
          {currencyFormat(row?.total_charges - row?.total_paid)}
        </div>
      );
    },
  },

  total_charges: {
    title: 'Total Invoice',
    format_number: true,
    sortable: false,
    width: 100,
    class: 'text-end',
    classHeader: 'text-end',
  },

  document_status: {
    title: 'Status',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 100,
    component: (row) => {
      return (
        <span className={`badge status-${row?.document_status}-lt ms-auto `}>
          {row?.document_status?.replace('new', 'proforma')?.replace('_', ' ')}
        </span>
      );
    },
  },

  shipment_code: {
    title: 'Resi',
    sortable: false,
    width: 50,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <small className="info text-uppercase">
            {row?.customer?.is_send_invoice &&
            row?.document_status !== 'new' ? (
              row?.shipment_code === '' ? (
                <Tb.TbMailX size="17" className="text-danger" />
              ) : (
                <>
                  <Tb.TbMailCheck size="17" className="text-success me-2" />
                  {row?.shipment_code}
                </>
              )
            ) : null}
          </small>
        </div>
      );
    },
  },

  is_send_invoice: {
    title: 'Send Email',
    sortable: false,
    width: 50,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <small className="info text-uppercase">
            {row?.is_send_email ? 'Sudah': 'Belum'}
          </small>
        </div>
      );
    },
  },

  action: {
    title: '',
    sortable: false,
    width: 50,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
